
















































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Thdata from "../../../store/entities/thdata";
import Echarts from "../threaltimedata/Echarts.vue";
import Echartser from "../threaltimedata/Echarts.vue";
import Echartsd from "../threaltimedata/Echarts.vue";
import Echartsl from "../threaltimedata/Echarts.vue";
import Echartsyi from "../threaltimedata/Echarts.vue";
import PageRequest from "@/store/entities/page-request";
// import echarts from 'Echarts'
Vue.prototype.$echarts = Echarts;
class PageThRealTimeDataRequest extends PageRequest {
  AddTime: Date = new Date();
  snid: String;
  locationName: String;
  StartDates: Date = new Date();
  EndDates: Date = new Date();
}
@Component({
  components: { Echarts, Echartser,Echartsd, Echartsl,Echartsyi},
})
export default class AnalyseThrealtimedata extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Date }) EndTime: Date;
  @Prop({ type: String }) snid: String;
  @Prop({ type: String }) locationName: String;
  @Prop({ type: String }) yieldly: string;
  @Prop({ type: String }) years: string;
  @Prop({ type: String }) grade: string;
  pagerequest: PageThRealTimeDataRequest = new PageThRealTimeDataRequest();
  componentKey: number = 10;
  componentKeyhumi: number = 10;
  datalist = [];
  legenddata: string = "";

  xAxisdata: string = "";

   PM25_seriesdata: string = "";
   PM10_seriesdata: string = "";
  yAxisdata: string = "";

  PM25_serieslist = [];
  
  thdata: Thdata = new Thdata();
  StartTime: string;
  list = [];

  PM25title: string = "";
  PM10title: string = "";

  title: string = "数据分析";

  PM25message: string = "";

  datetype: string = "day";
  startDate: Date = new Date();
  endDate: Date = new Date();
  monthDate: Date = new Date();
  polar: string = "";

  moisture: Number=0;
  
  Maxmoi: string = "";
  Minmio: string = "";
  async getPage() {
    //filters
    //debugger;
    //let ss=this.value;
    this.pagerequest.AddTime = this.EndTime;
    this.pagerequest.StartDates = this.EndTime;
    this.pagerequest.EndDates = this.EndTime;
    this.pagerequest.snid = this.snid;
    this.list = await this.$store.dispatch({
      type: "moisturedata/getPagedLast",
      data: this.pagerequest,
    });
    this.PM25title = "水分含量走势图";

    let titlelist = ["水分含量检测"];

    this.PM25_serieslist.push({
      name: "含水率",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });

    let timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_PM25 = [];
    for (let entry of this.list) {
        datalist_PM25.push(entry.moisture);
        timelist.push(
        this.GetDays(entry.addTime) + " " + this.GetMinutes(entry.addTime));
    }
    this.PM25message = datalist_PM25[datalist_PM25.length - 1];
   
    this.PM25_serieslist[0].data = datalist_PM25;

    this.legenddata = JSON.stringify(titlelist);
    this.PM25_seriesdata = JSON.stringify(this.PM25_serieslist);

    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
  get analyse() {
    return this.$store.state.moistureequipment.analyse;
  }
  async getThreshold() {
    var thresholdId;
    this.pagerequest.snid = this.snid;
    var elist = await this.$store.dispatch({
      type: "moistureequipment/getPageBymac",
      data: this.pagerequest,
    });
    if (elist.length > 0 && elist[0].gId != "" && elist[0].gId != undefined) {
      thresholdId = elist[0].gId;
    }
    else{
      thresholdId = 0;
    }
    var threshold = await this.$store.dispatch({
      type: "moisturethreshold/get",
      id: thresholdId,
    });
    this.Maxmoi = threshold.maX_moisture;
    this.Minmio= threshold.miN_moisture;
  }
  GetMinutes(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getHours()) +
      ":" +
      this.GetBqMinutes(date.getMinutes());
    return Str;
  }
  GetDays(time) {
    let date = new Date(time);
    let Str =
      this.GetBqMinutes(date.getMonth() + 1) +
      "." +
      this.GetBqMinutes(date.getDate());
    return Str;
  }
  GetBqMinutes(str) {
    if (str.toString().length == 1) {
      return "0" + str;
    }
    return str;
  }
  visibleChange(value: boolean) {
    // this.ThisThPaged();
    if (!value) {
      this.$emit("input", value);
      this.$emit("title", this.locationName);
    } else {
      // this.thdata = Util.extend(
      //   true,
      //   {},
      //   this.$store.state.thdata.analyseThdata
      // );
      let list = this.$store.state.moistureequipment.analysemiodata;
      this.moisture = list.moisture;
      
      this.getPage();
      this.getThreshold();
    }
  }

  cancel() {
    //this.getPage();
    this.$emit("input", false);
  }

  showEcharts() {
    this.componentKey += 1;
    this.componentKeyhumi += 1;
  }
  GetByDate() {
    if (
      this.pagerequest.StartDates.toString() != "" &&
      this.pagerequest.EndDates.toString() != ""
    ) {
      this.pagerequest.snid = this.snid;
      this.GetPageByDate();
    }
  }
  GetByMonth() {
    if (this.monthDate.toString() != "") {
      var currentY = this.monthDate.getFullYear();
      var currentM = this.monthDate.getMonth() + 1;
      var lastM = new Date(currentY, currentM, 0);
      var lastS = new Date(currentY, currentM - 1);
      this.pagerequest.StartDates = lastS;
      this.pagerequest.EndDates = lastM;
      this.pagerequest.snid = this.snid;
      this.GetPageByDate();
    }
  }
  async GetPageByDate() {
    this.list = await this.$store.dispatch({
      type: "moisturedata/getPageByDate",
      data: this.pagerequest,
    });
    this.PM25title = "水分含量走势图";
let titlelist = ["水分含量检测"];
   this.PM25_serieslist.push({
      name: "含水率",
      type: "line",
      data: [],
      areaStyle: {
        opacity: 0.8,
        color: {
          colorStops: [
            {
              offset: 0,
              color: "rgba(1,191,236)",
            },
            {
              offset: 1,
              color: "rgba(84, 112, 198)",
            },
          ],
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          type: "linear",
          global: false,
        },
      },
      markPoint: {
        data: [
          { type: "max", name: "最大值" },
          { type: "min", name: "最小值" },
        ],
      },
    });

    let timelist = [];
    // for (let i = 0; i < 24; i++) {
    //   timelist.push(i.toString() + ":00");
    // }

    let datalist_PM25 = [];
    for (let entry of this.list) {
        datalist_PM25.push(entry.moisture);
        timelist.push(
        this.GetDays(entry.addTime) + " " + this.GetMinutes(entry.addTime));
    }
    this.PM25message = datalist_PM25[datalist_PM25.length - 1];
   
    this.PM25_serieslist[0].data = datalist_PM25;

    this.legenddata = JSON.stringify(titlelist);
    this.PM25_seriesdata = JSON.stringify(this.PM25_serieslist);

    this.xAxisdata = JSON.stringify(timelist);
    this.showEcharts();
  }
}
